
<template>
    <div>
        <select :name="name" :disabled="disabled"></select>
    </div>
</template>

<script>
import 'selectize/dist/js/standalone/selectize.min.js';
import 'selectize/dist/css/selectize.css';

export default {
    props: {
        modelValue: {},
        options: {},
        nullable: {
            default: true,
            type: Boolean
        },
        name: {},
        disabled: {},
        create: {
            default: false,
        }
    },
    mounted(){
        // Get the jquery element
        const $htmlselect = $(this.$el).find('select');
        // Create the selectize element
        const select = $htmlselect.selectize({
            options: this.options,
            labelField: 'label',
            valueField: 'value',
            searchField: ['label'],
            onChange: this.onChange,
            onBlur: this.onBlur,
            create: this.create ? this.createNew : false,
        });
        this.selectize = select[0].selectize;
        // Init value
        if(this.current){
            this.selectize.setValue(this.current.value, false);
        }
        this.options.forEach(op => {
            this.new_options += op.value < 0 ? 1 : 0;
        });
    },
    watch: {
        modelValue(newvalue){
            this.selectize.setValue(newvalue, false);
        },
        options(newoptions){
            // Save the current value
            let currvalue = this.current ? this.current.value : null;
            // @Javi Nov2019, this is an old comment:
            // There is a bug here. This gets call in the eng/spa but i don't know why
            //console.log("Updated options: ", newoptions);
            this.selectize.clearOptions();
            this.new_options = 0;
            newoptions.forEach(op => {
                this.selectize.addOption(op); // If exits, nothing happens
                this.new_options += op.value < 0 ? 1 : 0;
            });
            // Update the current
            let newoption = this.current ? this.getOption(this.current.value): null;
            let newvalue = newoption ? newoption.value : null;
            this.current = newoption ? newoption : null;
            // Set current if not nullable
            if(!this.nullable && !newvalue){
                newvalue = newoptions[0].value;
                this.current = this.getOption(newvalue);
            }
            if(currvalue !== newvalue){
                this.$emit('update:modelValue', newvalue);
            }
        },
    },
    data(){
        let value = this.modelValue;
        // Set the default
        if(value === null && !this.nullable){
            value = this.options[0].value;
        }
        let current = this.getOption(value);
        return {current, selectize:null, new_options:0};
    },
    methods: {
        getOption(value){
            return this.options.find(item => {
                // It should be like this because the index can be a number or string
                return item.value == value;
            });
        },
        createNew(input){
            this.new_options++;
            const new_op = {value:-this.new_options, label:input};
            const new_op_selectize = {value:-this.new_options, label:"🆕 " + input};
            this.options.push(new_op);
            this.selectize.addOption(new_op_selectize);
            return new_op;
        },
        //
        // onChange is the callback of selectize that saves the current value
        //
        onChange(value){
            this.current = this.getOption(value);
        }, // onChange
        //
        // The value is propagated on the blur event
        //
        onBlur(){
            this.$nextTick(()=>{
                const value = this.current ? this.current.value : null;
                this.selectize.setValue(value, false);
                this.$emit('update:modelValue', value);
            });
        }, // onBlur
    } // methods
}
</script>